var map = {
	"./css/style.scss": 5453,
	"./data/brouchreData": 8478,
	"./data/brouchreData.json": 8478,
	"./data/products": 7469,
	"./data/products.json": 7469,
	"./fonts/Preahvihear-Regular.ttf": 6623,
	"./image/2mImg.jpg": 4596,
	"./image/apImg.jpg": 6040,
	"./image/bunImg.jpg": 8106,
	"./image/chickenMutton.jpeg": 3929,
	"./image/computer.gif": 5903,
	"./image/convenioImg.jpg": 4580,
	"./image/cpImg.jpg": 2559,
	"./image/crestImg.jpg": 6597,
	"./image/datesBg.avif": 3068,
	"./image/deliciousImg.jpeg": 3122,
	"./image/deliciousImg.jpg": 5548,
	"./image/foodBg.avif": 1859,
	"./image/fresh1.jpg": 8128,
	"./image/fresh2.jpg": 5870,
	"./image/fresh3.jpg": 2450,
	"./image/fresh4.jpg": 8769,
	"./image/frozenImage.jpg": 7965,
	"./image/frozenVeg.jpg": 4070,
	"./image/frujoyImg.jpg": 3922,
	"./image/funwaveImg.jpg": 4618,
	"./image/habit1.jpg": 5141,
	"./image/habit2.jpg": 5787,
	"./image/habit3.jpg": 738,
	"./image/habit4.jpg": 5952,
	"./image/habit5.jpg": 7283,
	"./image/habit6.jpg": 9278,
	"./image/habit7.jpg": 5985,
	"./image/habit8.jpg": 8303,
	"./image/habitImg.jpg": 5681,
	"./image/hafa1.jpg": 7771,
	"./image/hafa10.jpg": 1374,
	"./image/hafa11.jpg": 5822,
	"./image/hafa12.jpg": 7831,
	"./image/hafa13.jpg": 5951,
	"./image/hafa2.jpg": 4453,
	"./image/hafa3.jpg": 828,
	"./image/hafa4.jpg": 9885,
	"./image/hafa5.jpg": 3461,
	"./image/hafa6.jpg": 4947,
	"./image/hafa7.jpg": 4145,
	"./image/hafa8.jpg": 8148,
	"./image/hafa9.jpg": 8432,
	"./image/iceImg.jpg": 4298,
	"./image/img/2M.png": 5890,
	"./image/img/ADP.png": 5898,
	"./image/img/Frujoy.png": 4789,
	"./image/img/ITC.png": 5256,
	"./image/img/Javascript.png": 3137,
	"./image/img/MalasLogo.png": 3580,
	"./image/img/ManamaLogo.png": 2499,
	"./image/img/Mask group(8)-min.png": 2064,
	"./image/img/Mccain.png": 8991,
	"./image/img/Tailwind1.png": 40,
	"./image/img/Tropolite.png": 2334,
	"./image/img/VeebaLogo.png": 5304,
	"./image/img/aboutBanner.png": 3116,
	"./image/img/aboutBanner1.png": 6898,
	"./image/img/aboutBanner2.png": 9033,
	"./image/img/al-hafa.png": 5266,
	"./image/img/bootstrap.png": 7456,
	"./image/img/brand1.png": 5097,
	"./image/img/brand2.png": 1589,
	"./image/img/cavins.png": 6231,
	"./image/img/convenio.png": 4167,
	"./image/img/cp.png": 3088,
	"./image/img/crest.png": 4014,
	"./image/img/css.png": 8121,
	"./image/img/delicious.png": 8863,
	"./image/img/ecrubit.jpg": 9771,
	"./image/img/fresh2go.png": 741,
	"./image/img/fssai.png": 1735,
	"./image/img/funulave.png": 5285,
	"./image/img/html.png": 6105,
	"./image/img/logo.png": 7548,
	"./image/img/me-bg.png": 8268,
	"./image/img/me.png": 3749,
	"./image/img/nextjs-original 1-min.png": 7053,
	"./image/img/nodejs-original 1-min.png": 2236,
	"./image/img/president.png": 8894,
	"./image/img/profile.jpg": 5572,
	"./image/img/profile1.jpg": 656,
	"./image/img/reactjs.png": 493,
	"./image/img/recepie1.png": 5503,
	"./image/img/recepie2.png": 3989,
	"./image/img/recepie3.png": 2147,
	"./image/img/recepie4.png": 6555,
	"./image/img/redux.png": 7059,
	"./image/img/skills.png": 9135,
	"./image/img/tailwind.png": 4786,
	"./image/img/thirumala.png": 6428,
	"./image/img/typescript.png": 3124,
	"./image/img/veeba.jpg": 9485,
	"./image/img/veeba.png": 807,
	"./image/img/zepto-logo.png": 128,
	"./image/importedCheese.jpg": 3292,
	"./image/indianCheeseImg.jpg": 5149,
	"./image/itcImg.png": 5842,
	"./image/malas1.jpg": 4732,
	"./image/malas10.jpg": 5128,
	"./image/malas11.jpg": 7748,
	"./image/malas12.jpg": 7030,
	"./image/malas2.jpg": 3212,
	"./image/malas3.jpg": 4212,
	"./image/malas4.jpg": 2522,
	"./image/malas5.jpg": 2955,
	"./image/malas6.jpg": 64,
	"./image/malas7.jpg": 6889,
	"./image/malas8.jpg": 4632,
	"./image/malas9.jpg": 1239,
	"./image/manama1.jpg": 6367,
	"./image/manama2.jpg": 591,
	"./image/manama3.jpg": 9079,
	"./image/manama4.jpg": 8444,
	"./image/mcain1.jpg": 7693,
	"./image/mcain2.jpg": 8826,
	"./image/mcain3.png": 7230,
	"./image/mcain4.jpg": 8102,
	"./image/nachosImg.jpg": 7018,
	"./image/packingImg.jpg": 8424,
	"./image/parathaImg.jpg": 8006,
	"./image/saucesImg.jpg": 6112,
	"./image/tasneemImg.jpg": 6977,
	"./image/tirumala1.jpg": 8199,
	"./image/tirumala2.jpg": 8696,
	"./image/tirumala3.jpg": 2367,
	"./image/tirumala4.jpg": 5940,
	"./image/tirumala5.jpg": 4885,
	"./image/tropoliteImg.jpg": 3083,
	"./image/vamikaImg.png": 5071,
	"./image/veebaImg.jpg": 1878,
	"./image/vklImg.jpg": 2442,
	"./image/zippyImg.jpg": 837,
	"./resume/resume.pdf": 5655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5379;